import { IBaseElement, IClickElement } from './base-element';
import { PageRequest } from './page-request';

export class PortalUpdateEvent {
  public static EVENT_NAME: string = 'PortalUpdateEvent';

  constructor(
    public element: IBaseElement,
    public request: PageRequest,
    public saveToHistory: boolean
  ) {}
}
